import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { BoxShape, BoxViolin } from '../shape';
import { MaybeZeroX } from '../transform';
import { baseGeometryChannels, basePostInference, basePreInference, tooltip1d } from './utils';
var shape = {
  box: BoxShape,
  violin: BoxViolin
};
/**
 * Convert value for each channel to box shapes.
 *
 * p0           p2          p1
 *    ──────────┬──────────
 *              │
 *              │
 *              │
 *              │
 *              │
 *              │
 *              │ p3
 * p4 ┌─────────┴──────────┐ p5
 *    │                    │
 *    │                    │
 * p8 ├────────────────────┤ p9
 *    │                    │
 *    │        p10         │
 * p7 └─────────┬──────────┘ p6
 *              │
 *              │
 *              │
 *              │
 *              │
 *              │
 *              │
 *              │
 *   ───────────┴───────────
 * p12         p11           p13
 */
export var Box = function Box() {
  return function (index, scale, value, coordinate) {
    var X = value.x,
      Y = value.y,
      Y1 = value.y1,
      Y2 = value.y2,
      Y3 = value.y3,
      Y4 = value.y4,
      S = value.series; // Calc width for each box.
    // The scales for x and series channels must be band scale.
    var xScale = scale.x;
    var series = scale.series;
    var P = Array.from(index, function (i) {
      var groupWidth = xScale.getBandWidth(xScale.invert(+X[i]));
      var ratio = series ? series.getBandWidth(series.invert(+(S === null || S === void 0 ? void 0 : S[i]))) : 1;
      var width = groupWidth * ratio;
      var offset = (+(S === null || S === void 0 ? void 0 : S[i]) || 0) * groupWidth;
      var x = +X[i] + offset + width / 2;
      var low = +Y[i],
        q1 = +Y1[i],
        median = +Y2[i],
        q3 = +Y3[i],
        high = +Y4[i];
      var P13 = [[x - width / 2, high], [x + width / 2, high], [x, high], [x, q3], [x - width / 2, q3], [x + width / 2, q3], [x + width / 2, q1], [x - width / 2, q1], [x - width / 2, median], [x + width / 2, median], [x, q1], [x, low], [x - width / 2, low], [x + width / 2, low]];
      return P13.map(function (d) {
        return coordinate.map(d);
      });
    });
    return [index, P];
  };
};
Box.props = {
  defaultShape: 'box',
  defaultLabelShape: 'label',
  composite: false,
  shape: shape,
  channels: [].concat(_toConsumableArray(baseGeometryChannels({
    shapes: Object.keys(shape)
  })), [{
    name: 'x',
    scale: 'band',
    required: true
  }, {
    name: 'y',
    required: true
  }, {
    name: 'series',
    scale: 'band'
  }]),
  preInference: [].concat(_toConsumableArray(basePreInference()), [{
    type: MaybeZeroX
  }]),
  postInference: [].concat(_toConsumableArray(basePostInference()), _toConsumableArray(tooltip1d())),
  interaction: {
    shareTooltip: true
  }
};